import EmployerProjectIndexContainer from './EmployerProjectIndexContainer';
export default EmployerProjectIndexContainer;